import { render, staticRenderFns } from "./QuizOptions.vue?vue&type=template&id=5edb3cfd&"
import script from "./QuizOptions.vue?vue&type=script&lang=js&"
export * from "./QuizOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports